import React, { useEffect, useState } from "react";
import "../Admin/Event/AdminEvent.css";

interface EventDto {
    eventID: number;
    eventName?: string;
}

interface FunctionDto {
    functionId: number;
    functionName: string;
}

const AdminDrinkFunctionAllowance: React.FC = () => {
    const [events, setEvents] = useState<EventDto[]>([]);
    const [functions, setFunctions] = useState<FunctionDto[]>([]);

    const [eventId, setEventId] = useState<number>(0);
    const [eventName, setEventName] = useState<string>("");

    const [functionId, setFunctionId] = useState<number>(0);
    const [functionName, setFunctionName] = useState<string>("");

    const [maxDrinks, setMaxDrinks] = useState<number>(0);
    const [message, setMessage] = useState<string | null>(null);

    // ---------------- HENT EVENTS ----------------
    useEffect(() => {
        fetch("/api/events")
            .then(r => r.json())
            .then(data => {
                if (Array.isArray(data)) {
                    setEvents(data);
                }
            });
    }, []);

    // ---------------- EVENT CHANGE ----------------
    const handleEventChange = async (id: number) => {
        setMessage(null);           // 🔥 Fjern "Drinks gemt"
        setEventId(id);
        setFunctionId(0);
        setFunctionName("");
        setMaxDrinks(0);
        setFunctions([]);

        if (!id) {
            setEventName("");
            return;
        }

        const selected = events.find(e => e.eventID === id);
        setEventName(selected?.eventName || `Event ${id}`);

        const res = await fetch(`/api/events/${id}`);
        if (!res.ok) return;

        const data = await res.json();
        if (data.functions) {
            setFunctions(data.functions);
        }
    };

    // ---------------- FUNCTION CHANGE ----------------
    const handleFunctionChange = async (id: number) => {
        setMessage(null);
        setFunctionId(id);
        setMaxDrinks(0);

        const selected = functions.find(f => f.functionId === id);
        setFunctionName(selected?.functionName || "");

        if (!id || !eventId) return;

        try {
            const res = await fetch(
                `/api/admin/drinks-function?functionId=${id}&eventId=${eventId}`
            );

            if (!res.ok) return;

            const data = await res.json();

            if (data && typeof data.maxDrinks === "number") {
                setMaxDrinks(data.maxDrinks); // 🔥 FORUDFYLD
            }
        } catch {
            // ignore silently
        }
    };


    // ---------------- SUBMIT ----------------
    const submit = async () => {
        setMessage(null);

        if (!functionId || !eventId) {
            setMessage("Event og Function skal vælges");
            return;
        }

        await fetch("/api/admin/drinks-function", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                functionId,
                eventId,
                maxDrinks
            }),
        });

        setMessage("✅ Drinks gemt");
        setMaxDrinks(0);
    };

    return (
        <div className="form-container">
            <h2>
                {eventName || "Vælg event"}
                {functionName ? ` – ${functionName} → Vælg drinks` : ""}
            </h2>

            {message && <p className="success-message">{message}</p>}

            {/* EVENT */}
            <label>Event *</label>
            <select
                value={eventId}
                onChange={(e) => handleEventChange(Number(e.target.value))}
            >
                <option value={0}>-- Vælg event --</option>
                {events.map(e => (
                    <option key={e.eventID} value={e.eventID}>
                        {e.eventName || `Event ${e.eventID}`}
                    </option>
                ))}
            </select>

            {/* FUNCTION */}
            {eventId > 0 && (
                <>
                    <label>Function *</label>
                    <select
                        value={functionId}
                        onChange={(e) => handleFunctionChange(Number(e.target.value))}
                    >
                        <option value={0}>-- Vælg function --</option>
                        {functions.map(f => (
                            <option key={f.functionId} value={f.functionId}>
                                {f.functionName}
                            </option>
                        ))}
                    </select>
                </>
            )}

            {/* MAX DRINKS */}
            {functionId > 0 && (
                <>
                    <label>Max drinks *</label>
                    <input
                        type="number"
                        min={0}
                        value={maxDrinks}
                        onChange={(e) => setMaxDrinks(Number(e.target.value))}
                    />

                    <button className="add-btn" onClick={submit}>
                        Gem
                    </button>
                </>
            )}
        </div>
    );
};

export default AdminDrinkFunctionAllowance;
